export const BarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
    <rect x={2} y={12} width={5} height={10} rx={1} />
    <rect x={9.5} y={6} width={5} height={16} rx={1} />
    <rect x={17} y={2} width={5} height={20} rx={1} />
  </svg>
);
